// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// css
import '../../styles/components/common/Modal.scss';


function Modal({ className, open, dismissable, onDismiss, children }) {

  if (open) {
    return (
      <div className={classnames(['modal-component', className])}>
        <div className='modal-dialog'>
          {dismissable &&
            <span
              className='modal-close-button'
              onClick={onDismiss}
            >
              &times;
            </span>
          }
          {children}
        </div>
      </div>
    );
  }
  return <div />;
}

Modal.defaultProps = {
  open: false,
  dismissable: true
};

Modal.propTypes = {
  open: PropTypes.bool,
  onDismiss: PropTypes.func,
  dismissable: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/Modal.js